import React from 'react'
import Header from '../Layout/Header'

function SettingNew() {
  return (
    <div>
        <Header/>
        <div className='settings_treaass'>
        <div class="settings-header">Settings</div>
    <div class="container">
        {/* <div class="item">
            <label><img src="usdt-trc20.png" alt=""/> USDT (TRC-20)</label>
            <div class="input-box">
                <input type="text" placeholder="Enter Address"/>
                <img src="edit-icon.png" alt="Edit"/>
            </div>
        </div> */}
        <div class="item">
            <label><img src="usdt-bep20.png" alt=""/>INR</label>
            <div class="input-box">
                <input type="text" placeholder="Enter Address"/>
                <img src="edit-icon.png" alt="Edit"/>
            </div>
        </div>
        {/* <div class="item">
            <label><img src="polygon.png" alt=""/> NFT Transfer (Polygon)</label>
            <div class="input-box">
                <input type="text" placeholder="Enter Address"/>
                <img src="edit-icon.png" alt="Edit"/>
            </div>
        </div> */}
    </div>
        </div>
        <div style={{ height: "100px" }}></div>
    </div>
  )
}

export default SettingNew
